import { X } from 'lucide-react'
import { FileIcon } from './FileIcon'

export interface FileTab {
    path: string
    name: string
    isDirty: boolean
    isActive: boolean
}

interface FileTabsProps {
    tabs: FileTab[]
    onTabClick: (path: string) => void
    onTabClose: (path: string) => void
}

export function FileTabs({ tabs, onTabClick, onTabClose }: FileTabsProps) {
    if (tabs.length === 0) {
        return null
    }

    return (
        <div className="flex items-center bg-gray-50 dark:bg-black border-b border-gray-200 dark:border-gray-800 overflow-x-auto">
            {tabs.map((tab) => (
                <div
                    key={tab.path}
                    className={`
                        group flex items-center gap-2 px-3 py-2 border-r border-gray-200 dark:border-gray-800
                        cursor-pointer transition-colors min-w-0 max-w-xs
                        ${tab.isActive
                            ? 'bg-white dark:bg-black text-gray-900 dark:text-gray-100 border-b-2 border-b-blue-600'
                            : 'bg-gray-50 dark:bg-black text-gray-600 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-gray-900 hover:text-gray-900 dark:hover:text-gray-100'
                        }
                    `}
                    onClick={() => onTabClick(tab.path)}
                >
                    {/* File Icon */}
                    <FileIcon name={tab.name} size={14} className="flex-shrink-0" />

                    {/* File Name */}
                    <span className="text-sm truncate">
                        {tab.name}
                    </span>

                    {/* Unsaved Indicator or Close Button */}
                    {tab.isDirty ? (
                        <div className="w-2 h-2 rounded-full bg-blue-600 flex-shrink-0" />
                    ) : (
                        <button
                            onClick={(e) => {
                                e.stopPropagation()
                                onTabClose(tab.path)
                            }}
                            className="opacity-0 group-hover:opacity-100 transition-opacity p-0.5 rounded hover:bg-gray-200 dark:hover:bg-gray-600 flex-shrink-0"
                            aria-label="Close tab"
                        >
                            <X size={14} />
                        </button>
                    )}
                </div>
            ))}
        </div>
    )
}
